<template>
  <div>
    <b-row class="pt-2 pb-1">
      <b-col cols="6">
        <BreadcrumbMenu />
      </b-col>
    </b-row>

    <b-card v-if="$can('read', 'OperationalProcedureTemplate')" class="mx-2" no-body>
      <b-row class="m-2">
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label class="text-capitalize">{{ $t("table.show") }}</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
          <label class="text-capitalize">{{ $t("table.entries") }}</label>
        </b-col>

        <b-col cols="12" md="6">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('table.search') + '...'"
            />
            <b-button
              v-if="$can('create', 'OperationalProcedureTemplate')"
              variant="secondary"
              :to="{ name: 'configBauComplementTemplate' }"
            >
              <span class="text-nowrap text-capitalize">
                {{ $t("actions.add") }} Template
              </span>
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-table
        ref="refListTable"
        class="position-relative"
        :items="fetchList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        show-empty
        :empty-text="$t('no_record_found')"
      >
        <template #head(actions)="data">
          <span>{{ $tc(data.label, 2) }}</span>
        </template>

        <template #cell(actions)="data">
          <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>

            <b-dropdown-item
              v-if="$can('update', 'OperationalProcedureTemplate')"
              :to="{ name: 'configBauComplementTemplateEdit', params: { id_template: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50 text-capitalize">
                {{ $t("actions.edit") }}
              </span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="$can('delete', 'OperationalProcedureTemplate')"
              @click="confirmDelete(data.item.id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50 text-capitalize">
                {{ $t("actions.delete") }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted text-capitalize">
              {{
                $t("table.showing", {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}
            </span>
          </b-col>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <Pagination
              :totalList="totalList"
              :currentPage="currentPage"
              @updatePagination="update"
              :perPage="perPage"
            />
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BDropdown,
  BDropdownItem,
  BTable,
} from "bootstrap-vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import vSelect from "vue-select";
import Swal from "sweetalert2";
import axios from "@/libs/axios";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Pagination from "@/components/Pagination.vue";
import useList from "./useList";

export default {
  name: "BauComplementTemplatesIndex",
  components: {
    BreadcrumbMenu,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BDropdown,
    BDropdownItem,
    BTable,
    Pagination,
    vSelect,
    ToastificationContent,
  },
  setup() {
    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
    } = useList();

    const toast = useToast();

    const confirmDelete = (id) => {
      Swal.fire({
        title: "¿Estás seguro de eliminar la plantilla?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios.delete(`/v1/bau_complement_templates/${id}`).then(() => {
            refetchData();
            toast({
              component: ToastificationContent,
              props: {
                title: "Plantilla eliminada correctamente",
                icon: "CheckIcon",
                variant: "success",
              },
            });
          });
        }
      });
    };

    const update = (value) => {
      currentPage.value = value;
    };

    return {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      confirmDelete,
      update,
    };
  },
};
</script>
